var map = {
	"./1.png": 1538,
	"./2.png": 1539,
	"./3.png": 1540,
	"./4.png": 1541,
	"./5.png": 1542,
	"./6.png": 1543,
	"./7.png": 1544,
	"./8.png": 1545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1537;